export default {
    apiGateway: {
        REGION: process.env.REACT_APP_REGION,
        URL: process.env.REACT_APP_ADMINCONSOLE_API_URL+'/'
    },
    auth:{
        URL: process.env.REACT_APP_OE_ADMINCONSOLE_SSO_DOMAIN+'/'
    }
};
